/** Layout einer Seite lesen und aendern (D-07, BE-06). Aenderungen gehen immer vom gespeicherten Stand aus. */
import { useCallback } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { kachelLayoutLaden, kachelLayoutSpeichern, kachelLayoutZuruecksetzen } from '@/db/repositories/oberflaeche';
import type { FesterBereich } from '@/domain/types';
import { layoutAus, type KachelLayout } from '@/domain/oberflaeche/kacheln';

export function useKachelLayout(layoutId: string, fest?: FesterBereich) {
  const roh = useLiveQuery(() => db.oberflaeche.get(layoutId), [layoutId], undefined);
  const layout = layoutAus(roh, layoutId, fest);
  const aendern = useCallback(async (f: (l: KachelLayout) => KachelLayout) => {
    await kachelLayoutSpeichern(f(await kachelLayoutLaden(layoutId, fest)));
  }, [layoutId, fest]);
  const zuruecksetzen = useCallback(() => kachelLayoutZuruecksetzen(layoutId), [layoutId]);
  return { layout, aendern, zuruecksetzen };
}

/** Wie viele Spalten passen? Wie `PageGrid 'drei'`: ab 900 px zwei, ab 1280 px drei. */
export function spaltenAnzahl(breite: number): 1 | 2 | 3 {
  return breite >= 1280 ? 3 : breite >= 900 ? 2 : 1;
}
